import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ErrorComponent } from '@angular/synthrone-design/components';

@Component({
  selector: 'app-add-update-font-variant',
  templateUrl: './add-update-font-variant.component.html',
  styleUrls: ['./add-update-font-variant.component.scss']
})
export class AddUpdateFontVariantComponent implements OnInit {
 
  @ViewChild('fileNameContainer') fileNameContainer;
  @ViewChild('fontFile') fontFile;

  public newName: string;
  public weight: number;
  public style: string;
  public file: File;
  public submitClicked: boolean;
  public isEdit: boolean = false;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AddUpdateFontVariantComponent>,
      public dialog: MatDialog
  ) {
    this.submitClicked = false;
    this.newName = <string>this.data.oldName;
    this.weight = <number>this.data.oldWeight;
    this.style = <string>this.data.oldStyle;
  }

  ngOnInit() {
    if (this.data.dataId) {
      this.isEdit = true;
    }
  }

  closeWindow = (param = null) => {
      this.dialogRef.close(param);
  };

  canSubmit = () => {
      return (
        this.newName !== undefined &&
        this.newName !== this.data.oldName &&
        this.newName.length !== 0 &&
        this.weight !== undefined &&
        this.weight.toString().length !== 0 &&
        this.style !== undefined &&
        this.style.length !== 0 &&
        this.fontFile !== undefined &&
        this.fontFile.nativeElement.files.length !== 0
      );
  };

  submitFn = () => {
    this.submitClicked = true;
    this.data.callback({
      name: this.newName,
      weight: this.weight,
      style: this.style,
      file: this.fontFile.nativeElement.files[0]
    }).catch((error: any) => {
        this.submitClicked = false;
        this.showError(error);
        return Observable.throw(error)
    }
    ).subscribe((response) => {
        this.closeWindow(true);
    });
  };

  inputKeyUp = (event) => {
      if (event.key === 'Enter' && this.canSubmit()) {
          this.submitFn();
      }
  };

  showError(message: string) {
    let dialogRef = this.dialog.open(ErrorComponent, {
        data: {
            message: message
        }
    });
    return dialogRef.afterClosed();
  }

   getFileName(inputFile) {
    const fileInputValue = inputFile.target.value.split('\\').pop().split('/').pop();
    const fileName = (fileInputValue.length !== 0) ? fileInputValue : 'Pick a font file';
    this.fileNameContainer.nativeElement.innerHTML = fileName;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/add-update-font-variant/add-update-font-variant.component.ts